import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9chkzgo6: FaireBrandEntity = {
  token: "b_9chkzgo6",
  type: "brand",
  name: "Bravado Spice Co.",
  avatarUrl:
    "https://cdn.faire.com/fastly/c12f0b2eed39ef2b907e030ac11a4d5739adf8fa5c39a28f820754d50df97393.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/dc5cbfbcfe0aa8d60af0cd73b68fd9bac017a44009a91ea64c6c5deac10180ac.png",
  logoUrl:
    "https://cdn.faire.com/fastly/c12f0b2eed39ef2b907e030ac11a4d5739adf8fa5c39a28f820754d50df97393.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dc5cbfbcfe0aa8d60af0cd73b68fd9bac017a44009a91ea64c6c5deac10180ac.png",
  location: "Houston, TX, USA",
  minimumOrderDollars: 99,
  rating: 5,
  reviewCount: 24,
  isTopShop: true,
  isInsider: true,
  description:
    "Seasonal Note: Summer is here, and it's the peak season for outdoor entertaining and grilling. Father's Day cookouts, Fourth of July spreads, backyard BBQs, pool parties, sunset margaritas on the patio. Bravado's hot sauces, seasonings, and margarita mixers were built for this time of year. Stock up now and give your customers the flavors that belong at every table all summer long.\n\nAt Bravado Spice Co, we craft hot sauces to add depth, versatility, and heat to everyday meals. We do not sacrifice flavor for heat, or vice versa, as both are critical to a great hot sauce. The integrity of our products is paramount, and we are proud to use carefully sourced, whole-food ingredients: fruits, vegetables, chili peppers, and spices. All of our products are plant-based, seed oil-free, gluten-free, added-sugar-free, and packaged in glass. Our products stand out on the shelf with bright yet clean, simple designs that showcase the natural color of each sauce. Our mission is to be the “secret ingredient” in every pantry. \n\nWe have been featured on Hot Ones and have amassed over 100 Industry Awards. ",
  meta: {
    source: "api",
    importedAt: "2026-07-06T19:20:34.733Z",
    importedBy: "entity-db-cli",
  },
};
